import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Divider, message, Modal, Space} from 'antd';
import {useBeforeUnload} from 'react-use';

import NewsPreview from '@/page/component/NewsFormModal/NewsPreview';
import ExtraNewsForm from './ExtraNewsForm';
import {useExtraNewsStore} from './context';
import {saveNews} from './extra-news';

import styles from './ExtraNewsFormModal.module.less';

ExtraNewsFormWrapper.propTypes = {
    pageGridRef: PropTypes.object,
    closeModal: PropTypes.func.isRequired,
};

function ExtraNewsFormWrapper({pageGridRef, closeModal}) {
    const [loading, setLoading] = useState(false);
    const [store, dispatch] = useExtraNewsStore();
    useBeforeUnload(store.dirty, '确定关闭，已编辑内容将会丢弃');

    function onAddNews() {
        dispatch('addNewsItem');
    }

    function onDeleteNews(tmpId) {
        if (store.tmpIds.length <= 1) {
            message.warn(`至少要有一个图文`);
            return;
        }

        Modal.confirm({
            title: '警告',
            content: `确定删除当前图文?`,
            okButtonProps: {danger: true},
            onOk: () => {
                dispatch(['deleteNewsItem', tmpId]);
            },
        });
    }

    function onPreviewClick(tmpId) {
        dispatch(['activeNewsItem', tmpId]);
    }

    /**
     * 上下移动。
     *
     * @param tmpId 临时 id
     * @param to -1：上移， 1：下移
     */
    function onMoveToClick(tmpId, to) {
        dispatch(['moveNewsItem', {tmpId, to}]);
    }

    function onClose() {
        const {dirty} = store;
        if (dirty) {
            Modal.confirm({
                title: '警告',
                content: (
                    <>
                        <p>内容已修改，确定关闭？</p>
                        <p>当前修改内容将不会保存！</p>
                    </>
                ),
                okButtonProps: {danger: true},
                onOk: () => {
                    closeModal();
                },
            });
        } else {
            closeModal();
        }
    }

    function warn(curId, tmpId, msg) {
        message.warn(msg);
        if (curId !== tmpId) {
            onPreviewClick(tmpId);
        }
    }

    function onOk() {
        const {id, appId, currentTmpId, newsById, tmpIds} = store;
        if (!appId) {
            message.warn('未选择所属应用！');
            return;
        }

        for (const tmpId of tmpIds) {
            const news = newsById[tmpId];
            const {title, entrypointId, thumbAttachId} = news;
            if (!title) {
                warn(currentTmpId, tmpId, '标题不能为空');
                return;
            }
            if (!entrypointId) {
                warn(currentTmpId, tmpId, '未上传图文包或未选择入口文件');
                return;
            }
            if (!thumbAttachId) {
                warn(currentTmpId, tmpId, '未上传封面图片');
                return;
            }
        }

        const newsList = [];
        for (const tmpId of tmpIds) {
            const news = newsById[tmpId];
            newsList.push(news);
        }

        const result = {id, appId, items: newsList};
        console.table(result);
        setLoading(true);
        saveNews(result)
            .then(data => {
                console.log(data);
                if (id) {
                    pageGridRef.current.refresh && pageGridRef.current.refresh();
                } else {
                    pageGridRef.current.reload2FirstPage && pageGridRef.current.reload2FirstPage();
                }
                closeModal();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <div className={styles.container}>
                <div className={styles.main}>
                    <ExtraNewsForm />
                </div>
                <div className={styles.preview}>
                    <NewsPreview
                        selectable
                        editable
                        newsById={store.newsById}
                        tmpIds={store.tmpIds}
                        currentTmpId={store.currentTmpId}
                        onAddNews={onAddNews}
                        onDeleteNews={onDeleteNews}
                        onPreviewClick={onPreviewClick}
                        onMoveToClick={onMoveToClick}
                    />
                </div>
            </div>
            <Divider />
            <Space align="end" style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button onClick={onClose}>取消</Button>
                <Button type="primary" loading={loading} onClick={onOk}>
                    确定
                </Button>
            </Space>
        </>
    );
}

export default ExtraNewsFormWrapper;
